import { Falsy } from 'utility-types'
import { enum_stripe_product_type_enum } from '../../../generated/graphql'

type Input =
  | { id?: string | Falsy; product_type?: enum_stripe_product_type_enum | Falsy; isCustomPackage: boolean }
  | Falsy

export const visibleCartLineItemsFilter = (input: Input) => {
  if (!input) return true

  return (
    input.product_type !== enum_stripe_product_type_enum.FEE &&
    input.product_type !== enum_stripe_product_type_enum.SHIPPING_FEE
  )
}
